<template src= "./detail.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import $api2 from '@/plugins/axiosInstance.js'
import $api22 from '@/plugins/axiosInstance.js'
// Create a reference to the file we want to download
import optionData from '@/optionData/data'
import agTableComp from '@/optionData/agTableComp'
export const BtnDelete = Vue.extend({
  name : 'btnDelete',
  template: `
        <button style="height:30px; line-height:30px; padding:0 1rem;" @click="btnClickedHandler()" type="button" name="button" class="vs-component vs-button vs-button-dark vs-button-filled" >
          <span class="vs-button-text vs-button--text"> {{title}} </span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);">
          </span>
        </button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const DownLink = Vue.extend({
  name : 'downLink',
  template: `
      <a  target='_blank' :href='file' @click="btnClickedHandler2()" download>{{title}}</a>
    `,
  data(){
    return{
      title : '',
      name : '',
      file : ''
    }
  },
  created(){
    this.title = this.params.data.display_name
    this.file = this.params.data.remote_path
  },
  methods: {
    btnClickedHandler2() {
    }
  },
});
export const Radio = Vue.extend({
   name : 'radio',
  template: `
    <div style="height:100%; display:flex" >
      <vs-radio :disabled="disabled"  vs-name="checkLicensor"  v-model="check" :vs-value="value"></vs-radio>
    </div>
    `,
  data(){
    return{
      check : null,
      value : null,
      disabled : false
    }
  },
  watch :{
    'check'(e){
      this.btnClickedHandler()
    }
  },
  created(){
    this.check = this.params.context.componentParent.selectLicensor ? this.params.context.componentParent.selectLicensor.id : null
    this.value = this.params.value
    if(this.params.data.licensor.contractor_id != null) {
      this.disabled =true
    }
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
  
})
export const CheckBox = Vue.extend({
  name : 'checkBox',
  template: `

      <vs-checkbox class="inline-flex mt-2" v-model="check"></vs-checkbox>
    `,
  data(){
    return{
      check : false,
      value : {},
      disabled : false
    }
  },
  watch :{
    'check'(e){
      
      this.btnClickedHandler()
      let a = this.params.context.componentParent.advanceData.albums
      const idx = a.findIndex((item) => {return item.id === this.value.id})
      if(e == true){
        if(idx < 0){
          this.params.context.componentParent.advanceData.albums.push(this.value);
        }
      }else{
        this.params.context.componentParent.advanceData.albums.splice(idx,1)
      }
    }
  },
  
  created(){
    let t = this.params.context.componentParent.advanceData.albums
    this.value = this.params.data
    for(var i in t){
      if(t[i].id == this.value.id){
        this.check = true
      }
    }
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});


export default {
  name: 'memberDetail',
  data() {
    return {
      
      feeEditMode :false, //정산요율 수정 방지
      manager:null, //  담당자 보류
      ko : ko,
      // 기본정보
      state : 'verified', // 가입 상태 - 인증
      stateOption : [
      ...optionData.userState
      ],
      role: '',
      userId : null,
      email: null,
      language:  null,
      reference: null,
      marketing: false,
      notification_album : false,
      notification_sales : true,
      admin_nickname : null, 
      admin_slack_id : null,
      bankNameCode : null,
      sr_representative : null,
      
      managerList : [],
      memberOption : optionData.memberKeyword,
      roleOption: optionData.role,
      langOption: optionData.lang,
      referenceOption:optionData.reference,
      bankOption: optionData.bank,
      
      entityOption : optionData.entity,
      countryOption : optionData.country,
      dialingOption : optionData.dialing,
      paymentOption : optionData.payment,
      currencyOption: optionData.currency,
      
      //수정 불가 항몽
      userRole : null,
      userCurrency: null,

      identificationOtion: [
        {value: 'kr_resident', label: '주민등록번호'},
        {value: 'kr_business', label: '사업자등록번호'},
        {value: 'foreign_tax', label: 'Tax No.'},
      ],
      
      object :{
        
        bankaccount:{
          payoneer_activation_date: null,
          payoneer_customer_id: null,
          payoneer_payee_id: null,
          paypal_email : null,
          account_number: null,
          bank_branch: null,
          bank_name: null,
          bank_code : null,
          name: null,
          payment_method: null,
          address : {
            address_line: null,
            address_line2: null,
            city: null,
            district: null,
            postal_code: null,
          }
        },
        contract_end_date: null,
        contract_start_date: null,
        default_service_fee_kr: 50,
        default_service_fee_other: 50,
        company: null,
        currency: null,
        entity: null,
        ddex_partyid: null,  
        entity_address: {
          address_line: null, // 거주 주소
          address_line2: null, // 거주 주소
          country: null, // 거주 국가
          postal_code: null, // 거주 우편번호
        },
        entity_date: null,
        entity_identification: null,
        entity_identification_type: null,
        entity_tax_exemption: false,
        family_name: null,
        given_name: null,
        mims_account: null,
        nationality: null,
        phone: null,
        phone_countrycode: null,
      },

    
      
      

      // 메모 관리
      gridOptions :{ // 테이플 옵션
          context: {
              componentParent: this
          },
          onGridReady: function (event) {
            event.api.sizeColumnsToFit();
          },
          frameworkComponents : {
            btnDelete : BtnDelete,
            btnSelect : agTableComp.btnSelect,
          }
      },
      defaultColDef: {
          sortable: false,
          editable: false,
          resizable: false,
          suppressMenu: false,
          rowSelection:'single',
      },

      columnDefs: [
          {headerName: '등록일', field: 'created_at', filter: false,resizable:true, minWidth: 175,
            cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          {headerName: '내용',  field: 'text',  resizable:true, filter: false, minWidth: 450,cellRenderer: (data) => {
            return `<div>${data.value}</div>`
          }},
          {headerName: '관리자', field: 'user.admin_nickname', filter: false,minWidth: 200,},
          {headerName: '상세보기', field: 'text', filter: false,minWidth: 140,
            cellRendererParams: {
              clicked: function(data) {
                let text = data.text
                this.context.componentParent.confirm({
                  title : '메모 상세보기',
                  msg : `
                    <div class="vx-card" style="padding:5px;">
                      <textarea style=" color:inherit; height:auto; min-height:200px;" class="vs-textarea" readonly>${text}</textarea>
                    <div>
                  `,
                  action :()=>{}
                })
                
                
              }
            },
            cellRendererSelector: (data) => {
                  let dd={
                    component: 'btnSelect',
                    params: {
                        ...data.data,
                        title: '상세보기'
                    }
                } ;
                // if(this.selectTrack.track_id ==  data.data.track_id ){
                //     dd.params['disabled'] = true
                //     dd.params['title'] = '선택완료'
                // }
                
                return dd
            }
          },
          {headerName: '메모삭제', field: 'id', filter: false,minWidth: 140,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.openModal('removeMemo');
                this.context.componentParent.selectMemo = data.id
                
              }
            },
            cellRenderer: 'btnDelete'
          },
      ],
      
      selectMemo : null    ,
      memo: {
        listData: [],                  // 메모 리스트데이터
        pageSize: 0,                 // 메모 리스트 총 페이징
        currentPage: 1,
        totalPage: 0,                // 메모 리스트 페이징
        memoText : '',
        limit_box: {
          limit_model: 10,
          limit: [ // 리스트 제한갯수
            {value: 10, label: "10"},
            {value: 20, label: "20"},
            {value: 30, label: "30"},
            {value: 50, label: "50"},
          ],
        },
      },

      //  파일 --------
      selectFile : null,        // 선택파일ID 삭제용
      file: {
        listData: [],                  // 메모 리스트데이터
        pageSize: 0,                 // 메모 리스트 총 페이징
        currentPage: 1,
        totalPage: 0,                // 메모 리스트 페이징
      },
      files: [],              // 파일 데이터
      accept:"",
      extensions:'',
      multiple: false,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      uploadAuto: false,
      gridOptions2 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
            event.api.sizeColumnsToFit();
        },
        frameworkComponents : {
          btnDelete : BtnDelete,
          downLink : DownLink
        }
      },
      columnDefsFile: [
          {headerName: '파일명',  field: 'display_name',  filter: false,width: 275,
            cellRenderer: 'downLink'
          },
          {headerName: '등록일', field: 'created_at', filter: false,width: 175,
            cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          {headerName: '파일삭제', field: 'id', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.openModal('removeFile');
                this.context.componentParent.selectFile = data.id
                
              }
            },
            cellRenderer: 'btnDelete'
          },
      ],


      // 거래내역
      trans: {
        listData: [],                  // 메모 리스트데이터
        pageSize: 0,                 // 메모 리스트 총 페이징
        currentPage: 1,
        totalPage: 0,                // 메모 리스트 페이징
      },
      gridOptions3 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
            //event.api.sizeColumnsToFit();
        },
        frameworkComponents : {
          btnDelete : BtnDelete,
          downLink : DownLink,
          btnSelect : agTableComp.btnSelect,
          textRender : agTableComp.textRender,
        }
      },
      // advancepayment_id: null
      // aggregator_display_name: "FLO"
      // amount: 0.008481967
      // balance: 0.865804334820934
      // created_at: "2020-10-28T05:59:06.671Z"
      // description: null
      // id: 878
      // processing_date: "2020-10-28"
      // ref_code: "T201028-OS6GECR"
      // salesline_group_id: 317
      // type: "settlement"
      // updated_at: "2020-10-28T05:59:06.671Z"
      // user_id: 149
      // withdrawal_id: null
      columnDefsTrans: [
        {headerName: 'T-No', field: 'ref_code', filter: false,width: 275,},
        {headerName: '처리일',  field: 'processing_date',  filter: false,width: 275,
        cellRenderer: (data) => {
          return this.fixDate(data.value, 'yyyy-MM-dd')
        }},
        {headerName: '구분', field: 'type', filter: false,width: 170, cellRendererParams: {
            clicked: function(data) {
              this.context.componentParent.userExcel(data)
            }
          },
          cellRendererSelector: (data) => {
            let dd = {
              
              advance_payment : '선급금 상계', 
              withdrawal : '출금', 
              settlement : '정산금', 
              admin_payment : '관리자 지급', 
              admin_deduction : '관리자 차감'
            }
            let text = dd
            if(data.value == 'settlement'){
                return { 
                component: 'btnSelect',
                params: {
                  ...data.data,
                  title: '정산금 내역다운'
                }
              }
            }else if(data.value == 'advance_payment'){
              
              return { 
                component: 'textRender',
                params: {
                  ...data.data,
                  text:  dd[data.value] + ' - '+ data.data.advancepayment_ref_code
                }
              }
            }else{
              return { 
                component: 'textRender',
                params: {
                  ...data.data,
                  text:  dd[data.value]
                }
              }
            }
           
        }},
        {headerName: '금액', field: 'amount', filter: false,width: 200,cellRenderer: (data) => {
            let type = {
              advance_payment : '', 
              withdrawal : '', 
              settlement : '', 
              admin_payment : '', 
              admin_deduction : ''
            }
            
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            return `<span class=${ data.value < 0  ? 'blue' : 'red'}>`+  (data.value > 0 ? '+' : '')  + this.numberFormat(data.value)+`</span>`;
          }},
        {headerName: '잔액',      field: 'balance',     filter: false,width: 200,cellRenderer: (data) => {
          let dd = {
            eur : ' €', 
            usd : ' $', 
            krw : ' 원', 
          }
          return this.numberFormat(data.value) 
        }},
        {headerName: '파트너사',  field: 'aggregator_display_name',  filter: false,width: 155,},
      
      ],
  
      
      settleType : 'settle',
      settleOption: [
        {value: 'settle', label: '정산일자'},
        {value: 'service', label: '서비스시작일'},
      ],
      settleStartDate : moment(new Date()).format('YYYY-MM-DD'),
      settleEndDate : moment(new Date()).format('YYYY-MM-DD'),
      trackType : 'release_date' ,
      trackOption: [
        {value: 'release_date', label: '발매일'},
        {value: 'contract_start_date', label: '계약시작일'},
        {value: 'created_at', label: '등록일'},
      ],
      trackStartDate : moment(new Date()).format('YYYY-MM-DD'),
      trackEndDate : moment(new Date()).format('YYYY-MM-DD'),
      licensor: {
        listData: [],                 
        pageSize: 0,                 
        currentPage: 1,
        totalPage: 0,
        totalNum : 0,             
      },
      gridOptions4 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents : {
          btnDelete : BtnDelete,
          downLink : DownLink,
          radio : Radio,
          BtnSelect : agTableComp.btnSelect,
        }
      },
      columnDefsLicensor : [
        {headerName: 'E-mail ID', field: 'user.email', filter: false,width: 225,},
        {headerName: '권리자명 (성 이름)', field: 'family_name', filter: false,width: 200,
          cellRenderer: (data) => {
            let fm = data.data.family_name ? data.data.family_name : '';
            let gm = data.data.given_name ? data.data.given_name : '' ;
            return fm +' '+ gm
        }},
        {headerName: '회사명', field: 'company', filter: false,width: 200,},
        {headerName: '정산화폐', field: 'currency', filter: false,width: 150,
          cellRenderer: (data) => {
            const type = {
                'krw' : 'KRW',
                'usd' : 'USD',
                'eur' : 'EUR',
            }
            return type[data.value]
        }},
        {headerName: '사업자여부', field: 'entity', filter: false,width: 150, cellRenderer: (data) => {
            const type = {
                'individual' : '개인',
                'corporation' : '사업자',
            }
            return type[data.value]
        }},
        {headerName: '거주국가',  field: '',  filter: false,width: 155,},
        {headerName: 'MIMS',  field: 'mims_account',  filter: false,width: 200,
        cellRenderer: (data) => {
          return data.value
        }},
        {headerName: '삭제', field: 'id', filter: false,maxWidth: 140,
            cellRendererParams: {
              clicked: function(data) {
                let licensorId = data.id
                this.context.componentParent.confirm(
                  {
                    title : '삭제 확인',
                    msg : `
                    정말 삭제 하시겠습니까?
                    `,
                  action : ()=>{
                      console.log(licensorId);
                      let payload = {
                          id : `${this.context.componentParent.$route.params.id}`,
                          licensor_id:licensorId
                      }
                      
                      this.context.componentParent.loadingShow()
                      this.context.componentParent.$store.dispatch("DELETECONTRACTOR_LICENSOR", payload)
                      .then(result =>{
                          
                          this.context.componentParent.getLicensorList();
                          this.context.componentParent.noti('Licensor가 삭제되었습니다.')
                          this.context.componentParent.loadingHide();
                      }).catch(error =>{
                          this.context.componentParent.loadingHide();
                          switch(error.response.data.code) {
                            default:
                            this.alert({msg:error})
                            break;
                        }
                      })
                  }}
                );
                
                
              }
            },
            cellRenderer: 'btnDelete'
          },
      ],
      // 라이센서 추가
      gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents : {
          btnDelete : BtnDelete,
          downLink : DownLink,
          radio : Radio
        }
      },
      columnDefsUser : [
        {headerName: '선택', field: 'id', filter: false,width: 60,
          cellRendererParams: {
            clicked: function(field) {
              
              if(field.licensor.contractor_id != null){
                this.context.componentParent.alert({msg:'이미 Contractor 를 보유한 Licensor 입니다.'})
                return false
              }else{
                this.context.componentParent.selectLicensor = field
              }
              
            }
          },
          cellRenderer: 'radio'
        },
        {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
        {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
          cellRenderer: (data) => {
            let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
            let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
            return fm +' '+ gm
        }},
        {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
        
        {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
          cellRenderer: (data) => {
            const type = {
                'krw' : 'KRW',
                'usd' : 'USD',
                'eur' : 'EUR',
            }
            return type[data.value]
        }},
        {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
            const type = {
                'individual' : '개인',
                'corporation' : '사업자',
            }
            return type[data.value]
        }},
        {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
        {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
      ],
      keywordType : {label:'Email ID', value:'email'},
      licensorKeyword : '',
      selectLicensor:null,
      userList: {
        listData: [],                 
        pageSize: 5,                 
        currentPage: 1,
        totalPage: 0,                
      },
      advanceList : {
        listData: [],                 
        pageSize: 5,                 
        currentPage: 1,
        totalPage: 0,
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          frameworkComponents : {
            btnDelete : BtnDelete,
            downLink : DownLink,
            radio : Radio,
            btnSelect : agTableComp.btnSelect,
          }
        },
        columnDefs : [
          
          {headerName: '선급계약코드',  field: 'ref_code',  filter: false,width: 150,},
          {headerName: '선급계약일',  field: 'start_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          {headerName: '상계대상', field: 'albums', filter: false,width: 150, cellRenderer: (data) => {
               return  data.value.length
          }},
          {headerName: '총 선급금액', field: 'amount_total', filter: false,width: 150,
            cellRenderer: (data) => {
              return  this.numberFormat(data.value)
          }},
          {headerName: '누적상계금액', field: 'amount_total', filter: false,width: 150, cellRenderer: (data) => {
              let num =  data.data.amount_total - data.data.amount_remaining
              return  this.numberFormat(num)
          }},
          
          {headerName: '선급금잔액', field: 'amount_remaining', filter: false,width: 150,
            cellRenderer: (data) => {
               return  this.numberFormat(data.value)
          }},
          {headerName: '선급금정산요율', field: 'service_fee', filter: false,width: 150,
            cellRenderer: (data) => {
               return  this.numberFormat(data.value) + ' %'
          }},
          {headerName: '등록일시',  field: 'created_at',  filter: false,width: 200,
            cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd hh:mm:ss')
          }},
          {headerName: '상세보기',  field: 'created_at',  filter: false,width: 200,
            cellRendererSelector: (data) => {
                  let dd={
                    component: 'btnSelect',
                    params: {
                        ...data.data,
                        title: '상세보기'
                    }
                } ;
                // if(this.selectTrack.track_id ==  data.data.track_id ){
                //     dd.params['disabled'] = true
                //     dd.params['title'] = '선택완료'
                // }
                
                return dd
            },
            cellRendererParams: {
              clicked: function(data) {
                
                //this.context.componentParent.editAdvance(data)
                let url = '/advancepayment/detail/' +data.id
                window.open(url);
                //this.context.componentParent.closeModal('licensor')
              }
            },
          }
        ]
      },
      advanceData : {
        start_date : null,
        ref_code : null,
        amount_total : 0,
        service_fee : 0,
        amount_remaining :0,
        albums : [],
        files: [],
        listData: [],                 
        pageSize: 5,                 
        currentPage: 1,
        totalPage: 0,
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          frameworkComponents : {
            btnDelete : BtnDelete,
            downLink : DownLink,
            radio : Radio
          }
        },
        columnDefs : [
          
          {headerName: '발매일',  field: 'release_date',  filter: false,width: 130,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 130},
          {headerName: '앨범명', field: 'name', filter: false,width: 250,
          cellRenderer: (data) => {
            if(data.data.state =='trash'){
              return '<span style="color:red"> 임시삭제 - </span>' + data.value 
            }else{
              return data.value
            }
            
          }},
          {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
            cellRenderer: (data) => {
              let t = data.value
              let text =  ''
              for ( var i in t ){
                if(i != 0){
                  text += ', '
                }
                text += t[i].display_name
              }
              return text
          }},
          {headerName: '트랙수', field: 'track_count', filter: false,width: 80,},
          
          {headerName: '삭제',  field: 'created_at',  filter: false,width: 100,
            cellRenderer: 'btnDelete',
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.delete_album(data)
                //this.context.componentParent.closeModal('licensor')
              }
            },
          }
        ],
      },
      advanceDataType : null,
      albumOption :[
        {value: 'email', label:'Email ID'},
        {value: '_name', label:'앨범명'},
        {value: 'company', label: '회사명'},
        {value: 'album_ref',label: '자사앨범코드'},
        {value: 'barcode',label: 'UPC',},
        {value: 'artist',label: '아티스트명',},
        {value: 'artist_english',label: '아티스트명(번역)',},
      ],
      //상계대상 찾기 
      albumList : {
        keywordType : null,
        keyword : null,
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          frameworkComponents : {
            btnDelete : BtnDelete,
            downLink : DownLink,
            radio : Radio,
            checkBox : CheckBox
          }
        },
        columnDefs : [
          
          {headerName: '선택',  field: 'release_date',  filter: false,width: 100,
          cellRenderer: 'checkBox',
          cellRendererParams: {
            clicked: function(data) {
              
              //this.context.componentParent.closeModal('licensor')
            }
          },
            
          },
          {headerName: '발매일',  field: 'release_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 150},
          {headerName: '앨범명', field: 'name', filter: false,width: 200,},
          {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
            cellRenderer: (data) => {
              let t = data.value
              let text =  ''
              for ( var i in t ){
                if(i != 0){
                  text += ', '
                }
                text += t[i].display_name
                
              }
              return text
          }},
          {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
        ],
      },

      albumSearch : {
        optionData : optionData,
        state : null,
        source : null,
        copyright_type : null,
        apOption : null, // 선급계약여부  
        contract_territory : 'korea',
        keywordOption :[
            {value: 'email', label:'Email ID'},
            {value: '_name', label:'권리자명'},
            {value: 'name', label:'앨범명'},
            {value: 'company', label: '회사명'},
            {value: 'album_ref',label: '자사앨범코드'},
            {value: 'barcode',label: 'UPC',},
            {value: 'artist',label: '아티스트명',},
            {value: 'artist_english',label: '아티스트명(번역)',},
        ],
        keywordType :'name',
        keyword : '',

        startDate :null,
        endDate : null,
        dateType :'release_date' ,
    
        dateOption : [
            {value: 'release_date',label: '발매일',},
            {value: 'start_date',label: '계약시작일',},
            {value: 'created_at',label: '등록일',},
            {value: 'registered_at',label: '접수일',},
        ],
      },
      //유저 보유 앨범 목록
      userAlbumList : {
        keywordType : null,
        keyword : null,
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,
        total : 0,
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          frameworkComponents : {
            btnDelete : BtnDelete,
            downLink : DownLink,
            radio : Radio,
            checkBox : CheckBox
          }
        },
        columnDefs : [
          {headerName: '앨범 상세보기', field: 'id', filter: false,width: 120,cellRenderer: (data) => {
            return `<a class="vs-component vs-button mr-3 vs-button-primary vs-button-gradient" href='/album/detail/${data.value}' target="_blank">
            
            <span class="vs-button-text vs-button--text">상세보기</span>
            </a>`
          }},
          
          {headerName: '상태',  field: 'state',  filter: false,width: 100, cellRenderer: (data) => {
                    let dd = {
                        temporary :'임시저장',
                        registration_complete : '접수', 
                        registration_canceled : '유통 취소', 
                        inspection_complete : '검수 완료', 
                        distribution_complete : '유통 완료', 
                        release_complete : '발매 완료', 
                        suspended : '유통중단', 
                        rejected : '반려',
                        trash : '임시삭제'
                    }
                    let color = {
                        temporary : "#9544d0b3",//'임시저장',
                        registration_complete : '#262c49',//'접수', 
                        registration_canceled : '#797979',//'유통 취소', 
                        inspection_complete : '#4092ff',//'검수 완료', 
                        distribution_complete : '#ff9f43',//'유통 완료', 
                        release_complete : '#24c1a0',//'발매 완료', 
                        suspended : '#b8c2cc',//'유통중단', 
                        rejected : '#ea5455',//'반려' 
                        trash : "#737373"
                    }
                return `
                <div class="con-vs-chip vs-chip-primary con-color" 
                style="
                    background-color: ${color[data.value]} !important;
                    color:#fff;
                    line-height:1;
                    padding:3px 5px;
                    margin:13px 0; 
                    font-size:13px;
                    min-width:50px;
                ">
                    <span style="margin:0" class="text-chip vs-chip--text">
                    ${dd[data.value]}
                </span><!----></div>`
                }},
          {headerName: '발매일',  field: 'release_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          {headerName: '계약시작일',  field: 'contract.start_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          {headerName: '계약종료일',  field: 'contract.end_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 150},
          {headerName: '앨범명', field: 'name', filter: false,resizable : true, minWidth: 300,},
          {headerName: '앨범아티스트명', field: 'artists', filter: false,resizable : true, minWidth: 300,
            cellRenderer: (data) => {
              let t = data.value
              let text =  ''
              for ( var i in t ){
                if(i != 0){
                  text += ', '
                }
                text += t[i].display_name
                
              }
              return text
          }},
          {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
          {headerName: '앨범 국내정산요율', field: 'contract.service_fee_kr', filter: false,width: 200,},
          {headerName: '앨범 해외정산요율', field: 'contract.service_fee_other', filter: false,width: 200,},
          {headerName: '등록일',  field: 'created_at',  filter: false,width: 250,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd hh:MM:SS')
          }},
          {headerName: '접수일',      field: 'registered_at',     filter: false,width: 180,
          cellRenderer: (data) => {
          return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
        ],
      },
      //유저 상세 데이터
      defaultUser : {
        listData : [],
        gridOptions :{ // 테이블 옵션
          onRowClicked: (event)=>{
              
          },
        },
        defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: false,
            rowSelection:'single'
        },
        columnDefs: [
            
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
        ],
      },
      // 선급금 계약 편집데이터
      selectAdvanceData :{},

      withdrawalTable : {
        data:[
        ],
        pageSize : 10,
        currentPage: 1,                       // 현재 페이지
        totalPage: 0,                         // 총 페이지수
        gridOptions :{ // 테이플 옵션
          // onRowClicked: (event)=>{
          //       this.viewDetail(event)
          // },
          context: {
            componentParent: this
          },
          frameworkComponents : {
            agTableComp
          }
        },
        columnDefs: [
          // amount_after_tax: 95188
          // amount_before_tax: 86535
          // created_at: "2021-04-01T10:05:12.627Z"
          // currency: "krw"
          // fulfillment_timestamp: "2021-04-01T10:06:50.501Z"
          // id: 88
          // ref_code: "W210401-GOJM0J5"
          // rejected_reason: null
          // state: "fulfilled"
          // tax_amount: 8653
          // tax_invoice_checked: true
          // tax_invoice_timestamp: "2021-04-13T00:00:00.000Z"
          // tax_rate: 10
          // updated_at: "2021-04-01T10:06:50.501Z"
          // user_id: 1192
          {headerName: '신청일시',      field: 'created_at',     filter: false,width: 180,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
         {headerName: '진행상태',      field: 'state',     filter: false,width: 100,cellRenderer: (data) => {
            let dd = {
              requested: '출금신청',
              fulfilled: '지급완료',
              rejected :'반려완료'
            }
            let color = {
                  requested : '#262c49',//'접수', 
                  fulfilled : '#24c1a0',//'발매 완료', 
                  rejected : '#ea5455',//'반려' 
              }
            return `
              <div class="con-vs-chip vs-chip-primary con-color" 
              style="
                  background-color: ${color[data.value]} !important;
                  color:#fff;
                  line-height:1;
                  padding:3px 5px;
                  margin:13px 0; 
                  font-size:13px;
                  min-width:50px;
              ">
                  <span style="margin:0" class="text-chip vs-chip--text">
                  ${dd[data.value]}
              </span><!----></div>`
          }},
         
         
          {headerName: '출금신청금액',      field: 'amount_before_tax',     filter: false,width: 180,cellRenderer: (data) => {
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            return this.numberFormat(data.value)+ dd[data.data.currency];;
          }},
          {headerName: '적용세율',      field: 'tax_rate',     filter: false,width: 170, cellRenderer: (data) => {
            let dd = data.value + '%'
              if(data.data.user_entity_tax_exemption ){
                dd = '면세사업자' 
              }
            return dd
          }},
          {headerName: '예상 적용세액',      field: 'tax_amount',     filter: false,width: 200,cellRenderer: (data) => {
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            return this.numberFormat(data.value) + dd[data.data.currency];;
          }},
          {headerName: '실지급예상금액',      field: 'amount_after_tax',     filter: false,width: 200,cellRenderer: (data) => {
            let dd = {
              eur : ' €', 
              usd : ' $', 
              krw : ' 원', 
            }
            return this.numberFormat(data.value)+ dd[data.data.currency];;
          }},
         
          {headerName: '지급완료일',      field: 'fulfillment_timestamp',     filter: false,width: 200,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
          }},
          {headerName: '정산화폐',      field: 'currency',     filter: false,width: 100, cellRenderer: (data) => {
            let dd = data.value.toUpperCase()
            return dd
          }},
          // {headerName: '거주국가',      field: 'user_country',     filter: false,width: 100, cellRenderer: (data) => {
          //     let dd = data.value.toUpperCase()
          //   return dd
          // }},
          // {headerName: '지급방법',      field: 'user_payment_method',     filter: false,width: 100,cellRenderer: (data) => {
          //   let dd = {
          //     kr_banktransfer : " 계좌이체",
          //     intl_banktransfer : "WireTransfer",
          //     paypal : "Paypal",
          //     payoneer : "Payoneer",
          //   }
          //   return dd[data.value]
          // }},
          // {headerName: '사용자구분',      field: 'user_role',     filter: false,width: 100,cellRenderer: (data) => {
          //   let dd = {
          //     eur : ' €', 
          //     usd : ' $', 
          //     krw : ' 원', 
          //   }
          //   return this.$options.filters.title(data.value)
          // }},
          {headerName: '출금신청번호(W-No.)',      field: 'ref_code',     filter: false,width: 200},
        
        ],
      },
      changeEmailInput : null,
      statDateOption :[
        {value : 'settle',label :"정산월"},
        {value : 'service', label: "서비스월"}
      ],
      statDateType : 'settle',
      statStartDate : new Date(moment(new Date()).add('month', -5)) , 
      statEndDate : new Date(moment(new Date())), 
      chart: {
        trend_bar_x:{
            datasets: []
        },
        trend_bar: {
            data : {},
            option : { 
                responsive: true, maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        stacked: true,
                        //categoryPercentage: 0.5,
                        //barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                },
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        boxWidth: 80,
                        fontColor: this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'
                    }
                }
            }
        },
        summary_store:{
            data : {},
            options: {
                legend: {
                    display: true,
                    position: "right",
                    labels: {
                        boxWidth: 30,
                        fontColor: 'black',
                        padding: 40,
                        fontColor: this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'
                    }
                }
            }
        },
        summary_country:{
            data : {},
            options: {
                legend: {
                    display: true,
                    position: "right",
                    labels: {
                        boxWidth: 30,
                        fontColor: 'black',
                        padding: 40,
                        fontColor: this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'
                    }
                }
            }
        },
        album_popular:{
            bar_x:{
                type: 'y',
                datasets: [],
                options: {}
            },
            pie:{
                data : {},
                options: {
                    cutoutPercentage: 75,
                    legend: {
                        display: false,
                    }
                }
            },
            line:{
              data : {},
              options: {
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: false
                },
                legend : {
                  labels :{
                    fontColor: this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black',
                  }
                },
                
              }
            }
        },
        track_popular:{
            bar_x:{
                data : {},                    },
            pie:{
                data : {datasets :[]},
                options: {
                    cutoutPercentage: 75,
                    legend: {
                        display: false,
                    }
                }
            },
            line:{
                data : {},
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    },
                    legend : {
                      labels :{
                        fontColor: this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'
                      }
                    },
                    scales: {
                      
                    }
                }
            }
        },
        artist_popular:{
            bar_x:{
                data : {},                    },
            pie:{
                data : {datasets :[]},
                options: {
                    cutoutPercentage: 75,
                    legend: {
                        display: false,
                    }
                }
            },
            line:{
                data : {datasets :[]},
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    },
                    legend : {
                      labels :{
                        fontColor: this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'
                      }
                    },
                    scales: {
                      
                    }
                }
            }
        },
        
        store_popular:{
            bar_x:{
                data : {},                    },
            pie:{
                data : {datasets :[]},
                options: {
                    cutoutPercentage: 75,
                    legend: {
                        display: false,
                    }
                }
            },
            line:{
                data : {datasets :[]},
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    },
                    legend : {
                      labels :{
                        fontColor: this.$store.state.theme =='dark' ?  '#c2c6dc' : 'black'
                      }
                    },
                    scales: {
                     
                    }
                }
            }
        },
        
        country_popular:{
            bar_x:{
                data : {},                    },
            pie:{
                data : {datasets :[]},
                options: {
                    legend: {
                        display: false,
                    }
                }
            },
            line:{
                data : {datasets :[]},
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: false
                    }
                }
            }
        },

      },
      trend_filter : 'amounts',

      //요약
      top10Table : {
        listData:[
          // {"ref_id":776331,"title":"Higher Than","st_count":58448,"st_amount":118.2264353497045,"dl_count":73,"dl_amount":6.586047153283821,"other_count":10,"other_amount":1.3028081259963862,"total_amount":126.11529062898471,"sub_items":{"thumbnail":"https://storage.googleapis.com/srd-production-app-data/20210513045305024_02.%EC%BB%A4%EB%B2%84_kaypaige%20-%20higher%20than_thumb.jpg","artist_name":"KAYPAIGE"}},
          // {"ref_id":933356,"title":"CREW (Feat. Kyle Young)","st_count":1592,"st_amount":4.332573576518751,"dl_count":1,"dl_amount":0.22348821318756407,"other_count":0,"other_amount":0,"total_amount":4.556061789706315,"sub_items":{"thumbnail":"https://storage.googleapis.com/srd-production-app-data/20210526031255399_02.%EC%BB%A4%EB%B2%84_kaypaige%20-%20crew_thumb.jpg","artist_name":"KAYPAIGE"}},
          // {"ref_id":933357,"title":"CREW (Seoul Ver) (Feat. Kyle Young, SADBOY JB)","st_count":412,"st_amount":0.9597903102925129,"dl_count":1,"dl_amount":0.2251419721218379,"other_count":0,"other_amount":0,"total_amount":1.184932282414351,"sub_items":{"thumbnail":"https://storage.googleapis.com/srd-production-app-data/20210526031255399_02.%EC%BB%A4%EB%B2%84_kaypaige%20-%20crew_thumb.jpg","artist_name":"KAYPAIGE"}}
        ],
        pageSize : 10,
        currentPage: 1,                       // 현재 페이지
        totalPage: 0,                         // 총 페이지수
        
      },
      monthOption : 'track',
      monthSaleTable : {
        listData:[
          // {
          //   "title": "202107",
          //   "st_count": 745,
          //   "st_amount": 1.583159475,
          //   "dl_count": 3,
          //   "dl_amount": 0.516758535,
          //   "other_count": 8,
          //   "other_amount": 1.045503015,
          //   "total_amount": 3.145421025
          // },
          
          // {
          //   "title": "202109",
          //   "st_count": 24466,
          //   "st_amount": 52.062467379852684,
          //   "dl_count": 32,
          //   "dl_amount": 2.974600751622822,
          //   "other_count": 0,
          //   "other_amount": 0,
          //   "total_amount": 55.03706813147551
          // }
        ],
        pageSize : 10,
        currentPage: 1,                       // 현재 페이지
        totalPage: 0,                         // 총 페이지수
        
      },
      //앨범 트랙별
      albumTrackTable : {
        listData:[
          // {
          //   "ref_id": 83878,
          //    toggle : false,
          //   "title": "왜 이리 시끄러운 것이냐",
          //   "st_count": 5244347,
          //   "st_amount": 12465406.567141742,
          //   "dl_count": 11315,
          //   "dl_amount": 695279.593874076,
          //   "other_count": 44941,
          //   "other_amount": 392029.5206,
          //   "total_amount": 13552715.681615816,
          //   "sub_items": [
          //     {
          //       "ref_id": 308155,
          //       "title": "왜 이리 시끄러운 것이냐 (Prod. SLO)",
          //       "st_count": 4235559,
          //       "st_amount": 10528794.256975634,
          //       "dl_count": 9746,
          //       "dl_amount": 605631.8477115331,
          //       "other_count": 39858,
          //       "other_amount": 354228.355,
          //       "total_amount": 11488654.459687168
          //     },
          //     {
          //       "ref_id": 604973,
          //       "title": "논산 (Prod. SLO)",
          //       "st_count": 1008788,
          //       "st_amount": 1936612.3101661063,
          //       "dl_count": 1569,
          //       "dl_amount": 89647.74616254302,
          //       "other_count": 5083,
          //       "other_amount": 37801.1656,
          //       "total_amount": 2064061.2219286493
          //     }
          //   ]
          // }
        ],
        pageSize : 10,
        currentPage: 1,                       // 현재 페이지
        totalPage: 0,                         // 총 페이지수
        
      },
      //아티스트별
      artistTable : {
        listData:[
       
        ],
        pageSize : 10,
        currentPage: 1,                       // 현재 페이지
        totalPage: 0,                         // 총 페이지수
        
      },
      //뮤직스토어별
      storeTable : {
        listData:[
        ],
        pageSize : 10,
        currentPage: 1,                       // 현재 페이지
        totalPage: 0,                         // 총 페이지수
      },
      //국가별
      countryTable : {
        listData:[
        ],
        pageSize : 10,
        currentPage: 1,                       // 현재 페이지
        totalPage: 0,                         // 총 페이지수
      },
      countryChart : {}, 

      notiData : {
        release_data: null,
        album_name : null,
        artist_name : null,
        remark : null
      },

      permissionList : [],

      permissions : [],
    }
  },
  components : {
    btnDelete : BtnDelete
  },
  mounted(){
   this.$nextTick((vue) =>{
      if(this.$route.params){
        this.managerCall();
        this.statSummary()
        this.call();
        // setTimeout(() => {
        //   this.openModal('album')
        // this.albumCall()
        // }, 1000);
        
      }


      
    })
  },
  created(){
    //this.chart.album_popular.line.data = {"labels":["2021-05","2021-06","2021-07","2021-08","2021-09","2021-10"],"datasets":[{"label":"HIGHER THAN","data":[0,0,3.14,71.76,51.2,0],"backgroundColor":"transparent","borderColor":"rgba(54, 162, 235, 1)","pointBackgroundColor":"rgba(171, 71, 188, 1)"},{"label":"CREW (FEAT. KYLE YOUNG)","data":[0,0,0,1.13,3.42,0],"backgroundColor":"transparent","borderColor":"rgba(255, 100, 132, 1)","pointBackgroundColor":"rgba(171, 71, 188, 1)"},{"label":"CREW (SEOUL VER) (FEAT. KYLE YOUNG, SADBOY JB)","data":[0,0,0,0.77,0.4,0],"backgroundColor":"transparent","borderColor":"rgba(153, 102, 255, 1)","pointBackgroundColor":"rgba(171, 71, 188, 1)"}]}
    //this.chart.track_popular.line.data = {"labels":["2021-05","2021-06","2021-07","2021-08","2021-09","2021-10"],"datasets":[{"label":"HIGHER THAN","data":[0,0,3.14,71.76,51.2,0],"backgroundColor":"transparent","borderColor":"rgba(54, 162, 235, 1)","pointBackgroundColor":"rgba(171, 71, 188, 1)"},{"label":"CREW (FEAT. KYLE YOUNG)","data":[0,0,0,1.13,3.42,0],"backgroundColor":"transparent","borderColor":"rgba(255, 100, 132, 1)","pointBackgroundColor":"rgba(171, 71, 188, 1)"},{"label":"CREW (SEOUL VER) (FEAT. KYLE YOUNG, SADBOY JB)","data":[0,0,0,0.77,0.4,0],"backgroundColor":"transparent","borderColor":"rgba(153, 102, 255, 1)","pointBackgroundColor":"rgba(171, 71, 188, 1)"}]}
    
  },

  watch:{
    'role'(e){
      if(this.role == 'user'){
        this.object = {
          ...optionData.userObject
        }
        this.bankNameCode = null
      }else if(this.role == 'licensor'){
        this.object.default_service_fee_kr = 15
        this.object.default_service_fee_other = 15
      }else {
        this.object.default_service_fee_kr = 50
        this.object.default_service_fee_other = 50
      }
      
    },
   
    'object.nationality'(){
      
    },
    'object.entity'(){
      if(this.object.entity != 'corporation'){
        this.object.entity_identification_type = 'kr_resident'
        this.object.company = null
        this.object.entity_tax_exemption = false
      }else{
        this.object.entity_identification_type = 'kr_business'
        
      }
      if(this.object.entity_address.country != 'KR'){
        this.object.entity_identification_type = 'foreign_tax'
      }
    },
    'object.entity_address.country'(data){
      if(this.object.entity_address){
        if(this.object.entity_address.country == 'KR'){
          this.object.currency = 'krw'
          this.object.bankaccount.payment_method = 'kr_banktransfer'
          if(this.object.entity != 'corporation'){
              this.object.entity_identification_type = 'kr_resident'
          }else{
              this.object.entity_identification_type = 'kr_business'
          }
          //   {value: 'kr_resident', label: '주민등록번호'},
          //   {value: 'kr_business', label: '사업자등록번호'},
          //   {value: 'foreign_tax', label: 'Tax No.'},
        }else{
          this.object.entity_identification_type = 'foreign_tax'
          if(this.object.currency == 'krw') {
            this.object.currency = null
          }
          if(this.object.bankaccount.payment_method == 'kr_banktransfer'){
            this.object.bankaccount.payment_method = null
          }
        }
      }
      
    },
    'object.bankaccount.payment_method'(){
      
    },
    bankNameCode(){
      if(this.bankNameCode != null){
        this.object.bankaccount.bank_code = this.bankNameCode.code
        this.object.bankaccount.bank_name = this.bankNameCode.name
      }
      
    },
    'memo.currentPage'(){
        this.getMemoList()
    },
    'licensor.currentPage'(){
      this.getLicensorList()
    },
    'userList.currentPage'(){
      this.getUserList()
    },
    'trans.currentPage'(){
      this.getTransList()
    },
    'advanceList.currentPage'(){
      this.getAdvancepayment()
    },
    'albumList.currentPage'(){
      this.albumCall()
    },
    'userAlbumList.currentPage'(){
      this.getUserAlbum();
    },
    'withdrawalTable.currentPage'(){
      this.getWithdrawalList()
    },


    'albumTrackTable.currentPage'(){
      this.statAlbumeSale()
    },
    'artistTable.currentPage'(){
      this.statArtistSale()
    },
    'storeTable.currentPage'(){
      this.statStoreSale()
    }
    
  },

  methods: {
    
    call(){
        this.loadingShow()
        this.$store.dispatch("GET_USER_DETAIL_V2",{id:this.$route.params.id}).then((res)=>{
         console.log(res)
          let user = localStorage.getItem("userInfo")
          if(user){
            user = JSON.parse(user)
            if(user.email == res.email){
              localStorage.setItem("userInfo",JSON.stringify(res.data))
              this.$store.dispatch('updateUserInfo')
            }
          }
          let data = res
         
          // 기본정보 저장 //
          this.defaultUser.listData = [data]
          //
          this.admin_slack_id = data.admin_slack_id
          this.admin_nickname = data.admin_nickname
          this.state  = data.state
          this.role  = data.role
          this.userRole  = data.role
          this.email  = data.email
          this.language  = data.language
          this.reference  = data.reference
          this.marketing  = data.marketing
          this.notification_album = data.notification_album ? data.notification_album : false
          this.notification_sales = data.notification_sales ? data.notification_sales : false
          
          
          //this.permissions = data.permissions ? data.permissions : []

          this.permissions = []
           for(let i in data.permissions){
            this.permissions.push(data.permissions[i].id)
           }
          this.sr_representative  = data.sr_representative
          setTimeout(() => {
            if(this.role == 'licensor'){
              console.log(data.licensor)
              if(data.licensor ){
                this.object = data.licensor
              }
              const payload = {
                role: this.userRole,
                id: this.object.id,
              }
              this.getMemoList(payload)
            }else if(this.role == 'contractor'){
              if(data.contractor ){
                this.object = data.contractor
              }
              
              this.getLicensorList()
              const payload = {
                role: this.userRole,
                id: this.object.id,
              }
              this.getMemoList(payload)
            }
            if(!this.object.bankaccount || this.object.bankaccount.address == null) {
              this.object.bankaccount = {
                ...this.object.bankaccount,
                address : {
                  address_line: null,
                  address_line2: null,
                  city: null,
                  district: null,
                  postal_code: null,
                }
              }
            }
            
            this.bankNameCode ={
              name : this.object.bankaccount.bank_name ,
              code :this.object.bankaccount.bank_code 
            }
            if(this.object.entity_address && this.object.entity_address.country){
              this.object.entity_address.country = this.object.entity_address.country.toUpperCase()
            }else{
              this.entity_address = {
                address_line: null, // 거주 주소
                address_line2: null, // 거주 주소
                country: null, // 거주 국가
                postal_code: null, // 거주 우편번호
              }
            }
            
            console.log(this.object)
            this.userCurrency = this.object.currency
            // this = bankNameCode  = data.
            this.$EventBus.$emit('headerSet',{
              title : `사용자 상세(${this.email})`,
              subTitle : `${this.object.family_name ?  (this.object.family_name.trim() + ' ') : ''} 
                          ${this.object.given_name ?  (this.object.given_name.trim() + ' ') : ''} 
                          ${ this.object.company && (this.object.family_name || this.object.given_name)  ?  '/ ' : ''}  
                          ${this.object.company ? this.object.company : ''}` })
            this.loadingHide()
          }, 0);
          
        }).catch((err) => {
          console.log(err)
          //this.alert({msg:err.response.data.message})
        })
        this.$store.dispatch("GET_PERMISSION_LIST").then((result)=>{
          console.log(result.data.items)
          let item = result.data.items
          this.permissionList = item
        }).catch((err)=>{

        })
        
    },
    nullCheck(data){
      if(data == '' || data == null){
        return true
      }else{
        return false
      }
      
    },
    allNullCheck( checkList){
      let t = flatten(this.object)
      let msgList = {
        'entity' :'사업자구분을 선택해주세요.',
        'phone_countrycode' : '전화번호를입력해주세요.', 
        'phone' : '전화번호를입력해주세요.',
        'nationality' : '국가를 선택해주세요.',
        'company'  : '회사명을 입력해주세요.',
        'bankaccount.payment_method': '지급방법을 선택해주세요.' ,
        'entity_identification' : '납세자번호를 입력해주세요.',
        'currency' : '정산화폐를 선택해주세요.',
        'entity_address.country' : '거주국가를 선택해주세요.',
        'entity_date' : '생년월일(회사설립일을 입력해주세요.)',
        'entity_address.address_line':'거주지 주소를 입력해주세요.' ,
        'family_name': '성명을 모두 입력해주세요.' ,
        'given_name' : '성명을 모두 입력해주세요.',
        'default_service_fee_kr' : '국내정산요율을 입력해주세요',
        'default_service_fee_other' : '해외정산요율을 입력해주세요',
        'bankaccount.name' : '예금주를 입력해주세요.',
        'bankaccount.bank_code' : '은행코드를 입력해주세요.',
        'bankaccount.bank_name' :'은행명을 입력해주세요.' ,
        'bankaccount.bank_branch' : 'Bank Name을 입력해주세요',
        'bankaccount.account_number': '계좌번호를 입력해주세요',
        'bankaccount.address.address_line': 'Branch 주소를 입력해주세요.',
        'bankaccount.address.address_line2': 'Branch 상세주소를 입력해주세요.',
        'bankaccount.address.city': 'Branch City를 입력해주세요.',
        'bankaccount.address.district' : 'Branch District를 입력해주세요.',
        'bankaccount.address.postal_code' : 'Branch 우편번호를 입력해주세요.',
        'bankaccount.paypal_email' : 'Paypal ID를 입력해주세요.',
        'contract_end_date' : '계약 종료을 입력해주세요.', 
        'contract_start_date': '계약 시작일을 입력해주세요.',
      }
      for(var i in checkList){
        if(t[checkList[i]] == null || t[checkList[i]] == ''){
        
          this.alert({msg:msgList[checkList[i]]})
          return false;
        }
        
      }
      return true;
    },
    all_save(){
      
      this.closeModal('confirm')
      let params = {
        state : this.state, // 가입 상태 - 인증
        id: this.$route.params.id,
        role: this.userRole,
        language: this.language,
        reference: this.reference,
        marketing: this.marketing, 
        notification_album : this.notification_album,
        notification_sales : this.notification_sales,
        permissions : this.permissions
      }
      if(this.role != 'admin' ){
        params['sr_representative'] = this.sr_representative
      }
      if(this.role == 'admin'){
        if(!this.valCheck(this.admin_slack_id)){
        params['admin_slack_id'] = this.admin_slack_id
        }
        if(!this.valCheck(this.admin_nickname)){
          params['admin_nickname'] = this.admin_nickname
        }
      }
      
      let checkList = [];
      
      if(this.nullCheck(this.email)){
        this.alert({msg:'이메일을 입력해주세요.'})
        return false;
      }
      delete this.object.files; 
      delete this.object.memos;
      delete this.object.termsofuse;
      delete this.object.termsofuse_timestamp;
       
      if(this.valCheck(this.object.entity_date)){
        delete this.object.entity_date
      }
      if(this.role == 'licensor'){
          
          let licensor = { licensor :this.object }
          
          params = Object.assign(params, licensor)
          //라이센서 체크 리스트
          checkList = [
            'nationality',
            'entity',
            'entity_address.country',
            'currency',
            'bankaccount.payment_method',
            //'entity_identification',
            'default_service_fee_kr',
            'default_service_fee_other',
            ]
          if(params.entity == "corporation"){
            checkList.push('company')
          }
          if(this.valCheck(this.object.company)){
            checkList.push('family_name')
            checkList.push('given_name')
          }
         
          
      }else if(this.role == 'contractor'){
        // contractor check List 
        let contractor = { contractor : this.object}
        params = Object.assign(params, contractor)
        checkList = [
          'nationality',
          'entity',
          'entity_address.country',
          'currency',
          'bankaccount.payment_method',
          'entity_identification',
          'default_service_fee_kr',
          'default_service_fee_other',
          'contract_end_date',
          'contract_start_date'
        ]
        if(params.entity == "corporation"){
          checkList.push('company')
        }
        if(this.valCheck(this.object.company)){
          checkList.push('family_name')
          checkList.push('given_name')
        }
      }
                
      // 지급방법별 체크
      let checkList2 = []
      if(this.object.bankaccount.payment_method == 'kr_banktransfer'){
          checkList2 = [
            'bankaccount.name',
            'bankaccount.bank_code',
            'bankaccount.bank_name',
            'bankaccount.account_number',
          ]
          this.object.bankaccount.bank_branch = null
          this.object.bankaccount.paypal_email = null
          this.object.bankaccount.address = {
            address_line: null,
            address_line2: null,
            city: null,
            district: null,
            postal_code: null,
          }
        }
      if(this.object.bankaccount.payment_method == 'intl_banktransfer'){
        checkList2 = [
            'bankaccount.name',
            'bankaccount.bank_branch',
            'bankaccount.account_number',
            'bankaccount.address.address_line',
            // 해외 이체 시 주소 1만 입력
            // 'bankaccount.address.address_line2',
            // 'bankaccount.address.city',
            // 'bankaccount.address.district',
            // 'bankaccount.address.postal_code',
        ]
        this.object.bankaccount.bank_name = null
        this.object.bankaccount.paypal_email = null
      }
      if(this.object.bankaccount.payment_method == 'paypal'){
        checkList2 = [
            //'bankaccount.paypal_email'
        ]
        this.object.bankaccount.name = null
        this.object.bankaccount.bank_code = null
          this.object.bankaccount.account_number = null
          this.object.bankaccount.address = {
          address_line: null,
          address_line2: null,
          city: null,
          district: null,
          postal_code: null,
        }
      }
      checkList = _.concat(checkList, checkList2);
      
      //라이센서 컨트랙터 필수값 체크
      
      if(checkList.length > 0 && !this.allNullCheck(checkList)){
        return false
      }
      this.bankNameCode = null
      
      this.loadingShow()
      
      const payload = {id : params.id, params: params}
      
      this.$store.dispatch("PUTUSER", payload)
      .then(result =>{
        this.loadingHide();
        this.$vs.notify({text:'수정 되었습니다.',position:'top-center'})
        this.call();
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
             this.alert({msg:error})
            break;
        }
      })
    },
    memo_save() {
      this.closeModal('memo')
      const payload = {
        role: this.userRole,
        id: this.object.id,
        data: this.memo.memoText,
      }
      this.loadingShow()
      if(this.valCheck(this.memo.memoText)){
        this.alert({msg:'내용을 입력해주세요.'});
        return false;
      }
      this.$store.dispatch('POSTMEMO', payload)
      .then(result =>{
        this.loadingHide()
        this.memo.memoText = null
        this.getMemoList(payload)
        this.noti('메모가 추가되었습니다.')
        this.closeModal('memo')
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
            this.alert({
              msg : error.response.data
            }) 
          break;
        }
      })
    },
    getMemoList() {
      const payload = {
        role: this.userRole,
        id: this.object.id,
        params : {
          sort: 'created_at',
          sortorder: 'desc',
          page: this.memo.currentPage - 1,
          limit: 10
        }
      }
      this.$store.dispatch('GETMEMOLIST', payload)
      .then(result =>{
        this.loadingHide()
        this.memo.listData = result.data.items
        
        const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        this.memo.totalPage = parseInt(result.data.total/10) + remainder
      })
    },
    memo_delete(){
      this.closeModal('removeMemo')
      
      if(!this.selectMemo || this.selectMemo == '' ){
        this.alert({msg: '메모를 선택해주세요.'})
        return false;
      }
      const payload = {
        role: this.userRole,
        id: this.object.id,
        memo_id: this.selectMemo
      }
      this.$store.dispatch("DELETEMEMO", payload)
      .then(result =>{
        this.noti('메모가 삭제 되었습니다.')
        this.getMemoList()
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          case 1: 
            this.alert({
              msg : '권한이없습니다.'
            }) 
          break;
          default:
            this.alert({
              msg : error.response.data
            }) 
          break;
        }
      })
    },
    memo_delete2(id){
      
     this.confirm({
        title : '메모 삭제',
        msg : `
            선택하신 메모를 삭제하시겠습니까?
        `,
        action : ()=>{
            this.loadingShow()
           
            const payload = {
              role: this.userRole,
              id: this.object.id,
              memo_id: id
            }

            this.$store.dispatch("DELETEMEMO", payload)
            .then(result =>{
              this.noti('메모가 삭제 되었습니다.')
              this.getMemoList()
            }).catch(error =>{
              this.loadingHide();
              switch(error.response.data.code) {
                case 1: 
                  this.alert({
                    msg : '권한이없습니다.'
                  }) 
                break;
                default:
                  this.alert({
                    msg : error.response.data
                  }) 
                break;
              }
            })
        }
      })
      
      
    },
    openFile(){
      this.openModal('file')
      this.$nextTick(()=>{
        this.files = []
        setTimeout(() => {
          this.$refs.upload.drop = true  
          this.$forceUpdate();
        }, 0);
      })
    },
    getFileList() {
      const payload = {
        role: this.userRole,
        id: this.object.id,
        params : {
          sort: 'created_at',
          sortorder: 'desc',
          page: this.file.currentPage - 1,
          limit: 10
        }
      }
      this.loadingShow()
      this.$store.dispatch('GETFILELIST', payload)
      .then(result =>{
        this.file.listData = result.data
        this.loadingHide()
        // const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        // this.file.totalPage = parseInt(result.data.total/10) + remainder
      })
    },
    file_save(){
      if(this.files.length == 0 ){
        this.alert({msg:'파일을 선택해주세요.'})
        return false
      }
      const payload = {
        role: this.userRole,
        id: this.object.id,
        file: this.files[0].file,
      }
    
      this.loadingShow()
      this.$store.dispatch('POSTFILE', payload)
      .then(result =>{
        this.getFileList()
        
        this.closeModal('file')
        this.noti('파일이 등록되었습니다.');
        this.files = []
        
      }).catch(error=>{
        this.loadingHide()
        console.log(e)
        
      })
    },
    file_delete(){
      
      
      if(!this.selectFile || this.selectFile == '' ){
        this.alert({msg: '파일을 선택해주세요.'})
        return false;
      }
      this.closeModal('removeFile')
      this.loadingShow()
      const payload = {
        role: this.userRole,
        id: this.object.id,
        file_id: this.selectFile
      }
      this.$store.dispatch("DELETEFILE", payload)
      .then(result =>{
        this.noti('파일이 삭제 되었습니다.')
        this.getFileList()
      }).catch(error=>{
        this.loadingHide()
        const status = error.response.status
        switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
        }
      })
    },
    getTransList() {
      const payload = {
        role: this.userRole,
        id: this.$route.params.id,
        params : {
          sort: 'id',
          sortorder: 'desc',
          page: this.trans.currentPage - 1,
          limit: 10
        }
      }
      
      this.$store.dispatch('TRANSACTION_LIST', payload)
      .then(result =>{
        this.loadingHide()
        this.trans.listData = result.data.items
        
        const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        this.trans.totalPage = parseInt(result.data.total/10) + remainder
      }).catch(error=>{
        this.loadingHide()
        const status = error.response.status
        switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
        }
      })
    },
    getWithdrawalListpage(){
      this.withdrawalTable.currentPage = 1
      this.getWithdrawalList()
    },
    getWithdrawalList(){
      
      const payload = {
        id: this.$route.params.id,
        params : {
          sort: 'created_at',
          // sortorder: 'desc',
          page: this.withdrawalTable.currentPage - 1,
          limit: 10
        }
      }
      
      this.$store.dispatch('GET_USER_WITHDRAWAL', payload)
      .then(result =>{
        this.loadingHide()
        this.withdrawalTable.data = result.data.items
        
        const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        this.withdrawalTable.totalPage = parseInt(result.data.total/10) + remainder
      }).catch(error=>{
        this.loadingHide()
        const status = error.response.status
        switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
        }
      })
    },
    postUesrWithdrawal(){
        this.confirm({
        title : '대리 출금신청',
        msg : `
            출금 신청을 진행하시겠습니까??
        `,
        action : ()=>{
            const payload = {
              id: this.$route.params.id,
            }
            this.loadingShow()
            this.$store.dispatch('POST_USER_WITHDRAWAL', payload)
            .then(result =>{
              this.loadingHide()
              this.noti('신청되었습니다.')
              this.getWithdrawalList()
            }).catch(error=>{
                this.loadingHide()
                const status = error.response.status
                switch(status){
                  case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                  break;
                  case 405:
                    this.alert({msg: '출금가능한 금액이 아닙니다. <br> '})
                  break;
                  case 400:
                    this.alert({msg: '이미 진행중인 출금신청이 있습니다.'})
                  break;
                  case 500:
                    if(this.userCurrency.toUpperCase() == 'KRW'){
                      this.alert({msg: 'KRW는 50,000 이상만 출금 가능합니다'});
                    }else if(this.userCurrency.toUpperCase() == 'USD'){
                      this.alert({msg: 'USD는 100 이상만 출금 가능합니다'});
                    }else{
                      this.alert({msg: 'EUR은 100 이상만 출금 가능합니다'});
                    }
                    
                  break;
                  default:
                    this.alert({msg: error.response.data.message})
                  break;
                }
            })
        }
      })
      
    },

    //라이센서 관리
    getLicensorList() {
      const payload = {
        role: this.userRole,
        id: this.object.id,
        params : {
          sort: 'created_at',
          sortorder: 'desc',
          page: this.licensor.currentPage - 1,
          limit: 10
        }
      }
      this.$store.dispatch('GETCONTRACTOR_LICENSORS', payload)
      .then(result =>{
        
        this.licensor.listData = result.data.items
        
        const remainder = parseInt(result.data.total % 10) > 0 ? 1: 0
        this.licensor.totalPage = parseInt(result.data.total/10) + remainder
        this.licensor.totalNum = result.data.total
      }).catch(error=>{
        this.loadingHide()
        const status = error.response.status
        switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
        }
      })
    },
    openLicensor(){
      this.userList =  {
        
        listData: [],                 
        pageSize: 5,                 
        currentPage: 1,
        totalPage: 0,                
      },
      this.selectLicensor = null;
      this.keywordType = {label:'Email ID', value:'email'},
      this.licensorKeyword = '',
      this.openModal('licensor');
      this.getUserList()
    },
    searchUser(){
      this.userList.currentPage = 1 
      this.getUserList();
    },
    getUserList(num){
      
      const option = {
        sort: 'created_at',
        sortorder: 'desc',
        role : 'licensor',
        page: this.userList.currentPage - 1 ,
        limit: this.userList.pageSize
      }
      
      if(this.keywordType && this.keywordType !='') {
          option[this.keywordType.value] = this.licensorKeyword
      }
      this.$store.dispatch('GETUSER', option)
      .then(result =>{
          this.userList.listData  = result.items // 권리자 목록
          //페이지 수
          const remainder = parseInt(result.filtered % this.userList.pageSize) > 0? 1: 0
          this.userList.totalPage = parseInt(result.filtered /this.userList.pageSize) + remainder
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    //라이센서 추가
    confirmLicensor(){
      if(this.selectLicensor){
       this.openModal('confirmLicensor')
      }else{
        this.alert({msg:'Licensor를 선택해주세요.'})
      }
    },
    
    add_licensor(){
      this.closeModal('confirmLicensor')
      this.closeModal('licensor')
      this.loadingShow();
      let payload = {
        id : this.object.id,
        params : [this.selectLicensor.licensor.id]
      }

      this.$store.dispatch('POSTCONTRACTOR_LICENSORS', payload)
      .then(result =>{
          this.noti('Licensor가 추가 되었습니다.')
          this.loadingHide();
          this.getLicensorList()
      }).catch(error=>{
          this.loadingHide();
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
              this.alert({msg : error.response.data.message})
            break;
          }
      })
    },
    delete_licensor(){
      
    },
    getAdvancepayment(){

      const option = {
        sort: 'created_at',
        sortorder: 'desc',
        role : 'licensor',
        page: this.advanceList.currentPage - 1 ,
        limit: this.advanceList.pageSize
      }
      
      const payload ={
        id : this.object.id,
        params : option
      }
      this.$store.dispatch('GETADVANCEPAYMENT', payload)
      .then(result =>{
          this.advanceList.listData  = result.items // 권리자 목록
          //페이지 수
          const remainder = parseInt(result.filtered % this.advanceList.pageSize) > 0? 1: 0
          this.advanceList.totalPage = parseInt(result.filtered /this.advanceList.pageSize) + remainder
          
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    openAdvance(type){
      this.openModal('advance')
      this.advanceDataType = type
      if(type == 'add'){
        this.advanceData = {
          ...this.advanceData,
          ref_code : null,
          start_date : null,
          amount_total : 0,
          service_fee : 0,
          amount_remaining :0,
          albums : [],
          files : []
        }  
      }
      
    },
    editAdvance(data){
      console.log(data);
      this.advanceData = {
        ...this.advanceData,
        ...data
      }
      this.openAdvance('edit')
    },
    openAlbum(){
      this.openModal('album')
      this.albumList = {
        ...this.albumList,
        keywordType : null,
        keyword : null,
        listData: [],                 
        pageSize: this.albumList.pageSize,                 
        currentPage: 1,
        totalPage: 0,
      }
      this.albumCall()
    },
    getAlbumList(){
      this.albumList.currentPage = 1
      this.albumCall()
    },
    albumCall(){
      const payload = {
        id:this.object.id,
        params:{
          sort: 'created_at',
          sortorder: "desc",
          page: this.albumList.currentPage - 1,
          limit: this.albumList.pageSize,
          _ap: false
        }
      }
      if(this.albumList.keywordType && this.albumList.keywordType != '') {
        payload.params[this.albumList.keywordType.value] = this.albumList.keyword
      }
      this.$store.dispatch('GETOFFSETTINGALBUMLIST', payload)
      .then(result =>{
        
          this.albumList.listData  = result.items // 권리자 목록
          //페이지 수
          const remainder = parseInt(result.filtered % this.albumList.pageSize) > 0? 1: 0
          this.albumList.totalPage = parseInt(result.filtered /this.albumList.pageSize) + remainder
          
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },

    saveAdvance(){
      
      if(this.advanceDataType == 'add'){
        const payload = {
          id : this.object.id,
          params: {
            start_date :this.advanceData.start_date,
            amount_total : this.advanceData.amount_total,
            service_fee :	this.advanceData.service_fee,
            albums :[],
            files : [],
          }
        }
        
        if(this.valCheck(this.advanceData.start_date)){
          this.alert({msg:'계약시작일을 입력해주세요.'})
          return false
        }
        if(this.valCheck(this.advanceData.amount_total) && this.advanceData.amount_total == 0){
          this.alert({msg:'선급금액을 입력해주세요.'})
          return false
        }
        if(this.valCheck(this.advanceData.service_fee)&& this.advanceData.service_fee == 0){
          this.alert({msg:'선급금정산요율을 입력해주세요.'})
          return false
        }
        if(this.advanceData.service_fee > 100){
          this.alert({msg:'선급금정산요율은 100%를 넘을수 없습니다.'})
          return false
        }
        for(var i in this.advanceData.files){
          payload.params.files.push({id : this.advanceData.files[i].response[0].id})
        }
        for(var j in this.advanceData.albums){
          payload.params.albums.push({id : this.advanceData.albums[j].id})
        }
        
        this.loadingShow()
        this.$store.dispatch('POSTADVANCEPAYMENT', payload)
        .then(result =>{
            this.userList.listData  = result.items // 권리자 목록
            //페이지 수
            this.noti('선급금계약이 추가되었습니다.')
            this.loadingHide()
            this.getAdvancepayment()
            this.closeModal('advance')
        }).catch(error=>{
            this.loadingHide()
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg: error.response.data.message})
              break;
            }
        })
      }else{
        const payload = {
          id : this.object.id,
          advancepayment_id : this.advanceData.id,
          params: {
            albums :[],
            files : [],
          }
        }
        if(this.advanceData.albums.length == 0){
          this.alert({msg:'상계대상을 추가해주세요.'})
          return false
        }
        if(this.valCheck(this.advanceData.start_date)){
          this.alert({msg:'계약시작일을 입력해주세요.'})
          return false
        }
        if(this.valCheck(this.advanceData.amount_total) && this.advanceData.amount_total == 0){
          this.alert({msg:'선급금액을 입력해주세요.'})
          return false
        }
        if(this.valCheck(this.advanceData.service_fee)&& this.advanceData.service_fee == 0){
          this.alert({msg:'선급금정산요율을 입력해주세요.'})
          return false
        }
        if(this.advanceData.service_fee > 100){
          this.alert({msg:'선급금정산요율은 100%를 넘을수 없습니다.'})
          return false
        }
        for(var j in this.advanceData.albums){
          if(!this.advanceData.albums[j].advancepayment_id){
            payload.params.albums.push(this.advanceData.albums[j].id)
          }
        }
        this.loadingShow()
        this.$store.dispatch('POSTADVANCEPAYMENT_ALBUM', payload)
        .then(result =>{
            this.userList.listData  = result.items // 권리자 목록
            //페이지 수
            this.noti('선급금계약이 수정되었습니다.')
            this.loadingHide()
            this.getAdvancepayment()
            this.closeModal('advance')
        }).catch(error=>{
            this.loadingHide()
            const status = error.response.status
            switch(status){
              case 401:
              this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
              break;
              default:
                this.alert({msg: error.response.data.message})
              break;
            }
        })
      }
      
    },
    delete_album(data){
      const payload = {
        id : this.object.id,
        advancepayment_id : this.advanceData.id,
        album_id : data.id
      }
      this.confirm({
        title : '상계대상 삭제',
        msg : `
            선택하신 상계대상을 삭제하시겠습니까?
        `,
        action : ()=>{
            this.loadingShow()
            if(!data.advancepayment_id){
              const a = this.advanceData.albums
              const idx = a.findIndex((item) => {return item.id === data.id})
              this.advanceData.albums.splice(idx,1)
              setTimeout(() => {
                this.noti('삭제되었습니다.')
                this.loadingHide()
              }, 300);
            }else{
              
              this.$store.dispatch('DELETEADVANCEPAYMENT_ALBUM', payload)
              .then(result =>{
                this.loadingHide()
                const a = this.advanceData.albums
                const idx = a.findIndex((item) => {return item.id === data.id})
                this.advanceData.albums.splice(idx,1)
                this.noti('삭제되었습니다.')
                this.getAdvancepayment()
              }).catch(error=>{
                  this.loadingHide()
                  const status = error.response.status
                  switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                      this.alert({msg: error.response.data.message})
                    break;
                  }
              })
              
              
            }
            
        }
      })
      
    },
    //유저 앨범
    openAlbumTab(){
      this.userAlbumList.currentPage=1
      this.getUserAlbum()  
    },
    resetSearch (){
        this.userAlbumList.currentPage = 1
        this.albumSearch.copyright_type = null
        this.albumSearch.keywordType = null
        this.albumSearch.keyword = ''
        this.albumSearch.state = null
        this.albumSearch.source = null
        this.albumSearch.dateType = null
        this.albumSearch.startDate = null
        this.albumSearch.endDate = null
        this.albumSearch._ap = null
        this.getUserAlbum() 
    },
    getUserAlbum(){
    
      const payload = {
        id:this.object.id,
        params : {} 
      }
      
      let option ={
        sort: 'created_at',
        sortorder: 'desc,desc',
        page: this.userAlbumList.currentPage-1 ,
        limit: this.userAlbumList.pageSize,
        
      }
   
      if(this.albumSearch.keywordType && this.albumSearch.keyword != '') {
          option[this.albumSearch.keywordType] = this.albumSearch.keyword
      }
      if(!this.valCheck(this.albumSearch.dateType) && !this.valCheck(this.albumSearch.startDate )&& !this.valCheck(this.albumSearch.endDate) ){
          option['date_field'] = this.albumSearch.dateType
          option['date_start'] = this.albumSearch.startDate
          option['date_end'] = this.albumSearch.endDate
          if(this.dateType !== 'created_at' ){
              option['sort'] = this.albumSearch.dateType +',created_at'
          }else{
              option['sort'] = this.albumSearch.dateType
          }
      }
      if(!this.valCheck(this.albumSearch.state)){
          option['state'] = this.albumSearch.state
      }
      if(!this.valCheck(this.albumSearch.source)){
          option['source'] = this.albumSearch.source
      }
      if(!this.valCheck(this.albumSearch.copyright_type)){
          option['copyright_type'] = this.albumSearch.copyright_type
      }
      if(!this.valCheck(this.albumSearch.apOption)){
          option['_ap'] = this.albumSearch.apOption
      }
      payload.params = option
      this.loadingShow()
      this.$store.dispatch('GETOFFSETTINGALBUMLIST', payload)
      .then(result =>{
          this.loadingHide()
          this.userAlbumList.listData  = result.items // 권리자 목록
          this.userAlbumList.total = result.filtered
          //페이지 수
          const remainder = parseInt(result.filtered % this.userAlbumList.pageSize) > 0? 1: 0
          this.userAlbumList.totalPage = parseInt(result.filtered /this.userAlbumList.pageSize) + remainder
          
      }).catch(error=>{
          this.loadingHide()
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    changeEmail(){
      if(this.valCheck(this.changeEmailInput)){
        this.alert({msg:'변경할 이메일을 입력해주세요.'});
        return false
      }
      let emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailReg.test(this.changeEmailInput)){ // 이메일 정규식 체크
        this.alert({msg:'이메일형식이 맞지 않습니다.'});
        return false;
      }

      let payload = {
        id: this.$route.params.id,
        params:{email: this.changeEmailInput}
      }
      this.$store.dispatch("PUTUSER", payload)
      .then(result =>{
        this.loadingHide();
        this.closeModal('email')
        this.alert({msg:'수정 되었습니다.'})
        this.call();
      }).catch(error =>{
        this.loadingHide();
        console.log(error.response.data.code)
        switch(error.response.data.code) {
          case 56:
              this.alert({
                msg : '이미 사용중인 이메일입니다.'
              }) 
            break;
          default:
            this.alert({msg:error})
          break;
        }
      })
    },
    getExcelFile(response){
      let filename = "",
          disposition = response.headers["content-disposition"];
        
      if (disposition && disposition.indexOf("attachment") !== -1) {
          let filenameRegex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/, matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
          }
      }

      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
          window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              filename);
      } else {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
      }
    },
  
    userExcel(option){
      this.loadingShow();
      this.$store.dispatch('GET_USER_TRANSACTION_EXCEL', option)
        .then(result =>{
            this.loadingHide();
            console.log('result',result)
            this.getExcelFile(result)
        }).catch(error=>{
            const status = error.status
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                break;
            }
      })
    },
    getMonthFormat(val){
        return val.substring(0, 4) + '-' + val.substring(4, 6)
    },
    getRate(val, total){
        let value = 0
        if(val && total){
            value = val
        }
        if(!total){
            return 0
        }
        return Math.floor(value * 1000 / total) / 10
    },
    toggleItem(item){
        if(item.toggle){
            item.toggle = false
        }else{
            item.toggle = true
        }
    },
    getCountry(code){
        let country_name = ""
        
        this.countryOption.map(country =>{
            
            if(country.code.toLowerCase() == code.toLowerCase()){
                country_name = country.name
            }
        })
        if(!country_name){
            return code
        }
        return country_name
    },
    setPopularChart(name, result){
      const chart = this.chart

      let pop_datasets = []
      let bg_color = ["#36a2eb", "#ff6484", "#9966ff", "#ff9f40", "#ffce58", "#4bbfbf", "#000000"]
      let line_color = ["rgba(54, 162, 235, 1)", "rgba(255, 100, 132, 1)", "rgba(153, 102, 255, 1)", "rgba(255, 159, 64, 1)", "rgba(255,206,88, 1)"]
      
      let pie_values = []
      let pie_labels = []
      let line_labels = []
      let line_datas = []
      //라인 라벨 구성
      let label_date = moment(this.statStartDate)
      while(label_date.format('YYYYMM') <= moment(this.statEndDate).format('YYYYMM')){
          line_labels.push(label_date.format('YYYY-MM'))
          label_date = label_date.add(1, 'M')
      }
      if(result.items && result.items.length > 0){
          for(var i=0; i<result.items.length; i++){
              let item = result.items[i]
              let data = {
                  is_all: false,
                  label: item.title ? item.title.toUpperCase() : '-',
                  backgroundColor: bg_color[i],
                  price: (item.total_amount),
                  percentage: this.getRate(item.total_amount, result.summary.total)
              }
              let index = pie_labels.indexOf(item.title ? item.title.toUpperCase() : '-');
              if(index > -1 ){
                  pie_values[index] = pie_values[index] + (item.total_amount)
                  console.log(pop_datasets[index].price , item.total_amount)
                  pop_datasets[index].price = ((pop_datasets[index].price)  + (item.total_amount))
              }else{
                  pie_labels.push(item.title ? item.title.toUpperCase() : '-')
                  pie_values.push((item.total_amount))
                  pop_datasets.push(data)
                  
                  // line data
                  let line_val = []
                  line_labels.forEach((label) =>{
                      line_val.push(0)
                  })
                  if(item.sub_items && item.sub_items.length > 0){
                      item.sub_items.forEach((sub_item) => {
                          const index = line_labels.indexOf(this.getMonthFormat(sub_item.stats_month))
                          line_val[index] = (sub_item.total_amount)
                      })
                  }
                  let line_label = item.title ? item.title.toUpperCase() : '-'
                  if(name == 'country_popular'){
                      line_label = this.getCountry(line_label)
                  }
                  line_datas.push({
                      label: line_label, // item name
                      data: line_val,  // item data  Y축
                      backgroundColor: "transparent",
                      borderColor: line_color[i],
                      pointBackgroundColor: "rgba(171, 71, 188, 1)"
                  })
              }
          }
          console.log('result.summary',result.summary)
          if(result.summary.others > 0){
              pop_datasets.push({
                  is_all: false,
                  label: 'Others',
                  backgroundColor: bg_color[result.items.length],
                  price: (result.summary.others),
                  percentage: this.getRate(result.summary.others, result.summary.total)
              })
              
              pie_labels.push('Others')
              pie_values.push((result.summary.others))
          }
          pop_datasets.push({
              is_all: false,
              label: 'Total',
              backgroundColor: bg_color[6],
              price: (result.summary.total),
              percentage: 100
          })
      }
      this.chart[name]['bar_x']['datasets'] = pop_datasets
      this.chart[name]['bar_x']['options'] = { legend: false }

      this.chart[name]['pie']['data'] = {
          type: "y",
          datasets:[
              {
                  hoverBorderWidth: 2,
                  borderWidth: 2,
                  weight: 10,
                  backgroundColor: bg_color,    // Graph Color 
                  data: pie_values,                                                 // Data 
              }
          ],
          labels : pie_labels
      }
      this.chart[name]['line']['data'] = {
          labels: line_labels,
          datasets: line_datas
      }
      console.log('12312312213',JSON.stringify(this.chart[name]['line']['data']))
    },
    getStatMonthly(type){
        let payload = {
          id : this.$route.params.id, 
          url : type ? type : null, // album, track, artist , country, monthly, store, track
          params : {
            sort: 'title',
            sortorder: 'ASC',
            page: 0,
            limit: 12,
            date_type: this.statDateType,
            start_month: moment(this.statStartDate).format('yyyyMM'),
            end_month: moment(this.statEndDate).format('yyyyMM'),
          }
        }
        return this.$store.dispatch("GET_USER_STATS", payload)
          .then(result =>{
              
            this.monthSaleTable.sum = result.sum
            this.chart.trend_bar_x.datasets = [
              {   
                  //bar: { categoryPercentage: 0.5, barPercentage: 1 },
                  is_all: false,
                  label: 'Streaming',  // 이름
                  backgroundColor: "#36a2eb",                                                  // Bar Color
                  count : (this.monthSaleTable.sum.st_count),
                  price : (this.monthSaleTable.sum.st_amount),                    
                  amount_rate: this.getRate(this.monthSaleTable.sum.st_amount, this.monthSaleTable.sum.total_amount),
                  count_rate: this.getRate(this.monthSaleTable.sum.st_count, 
                  this.monthSaleTable.sum.st_count + this.monthSaleTable.sum.dl_count + this.monthSaleTable.sum.other_count),
              },
              {
                  //bar: { categoryPercentage: 0.5, barPercentage: 1 },
                  is_all: false,
                  label: 'Download',  // 이름
                  backgroundColor: "#ff6484",                                                 // Bar Color
                  count : (this.monthSaleTable.sum.dl_count),
                  price : (this.monthSaleTable.sum.dl_amount),                    
                  amount_rate: this.getRate(this.monthSaleTable.sum.dl_amount, this.monthSaleTable.sum.total_amount),
                  count_rate: this.getRate(this.monthSaleTable.sum.dl_count, 
                  this.monthSaleTable.sum.st_count + this.monthSaleTable.sum.dl_count + this.monthSaleTable.sum.other_count),
              },
              {
                  is_all: false,
                  label: 'Other',     // 이름
                  backgroundColor: "#4cc0c0",                                                 // Bar Color
                  count : (this.monthSaleTable.sum.other_count),
                  price : (this.monthSaleTable.sum.other_amount),                    
                  amount_rate: this.getRate(this.monthSaleTable.sum.other_amount, this.monthSaleTable.sum.total_amount),
                  count_rate: this.getRate(this.monthSaleTable.sum.other_count, 
                  this.monthSaleTable.sum.st_count + this.monthSaleTable.sum.dl_count + this.monthSaleTable.sum.other_count),
              },
              {
                  is_all: true,
                  label: 'All',       // 이름
                  backgroundColor: "#2548ca",                                                 // Bar Color
                  count : (this.monthSaleTable.sum.st_count + this.monthSaleTable.sum.dl_count + this.monthSaleTable.sum.other_count ),
                  price : (this.monthSaleTable.sum.total_amount),                    
                  amount_rate: 100,
                  count_rate: 100,
              },
            ]
            let labels = []
            let values = {
                st: [],
                dl: [],
                other: []
            }
            result.items.forEach((data)=> {
                labels.push(this.getMonthFormat(data.title))
                if(this.trend_filter == 'amounts'){
                    values.st.push((data.st_amount))
                    values.dl.push((data.dl_amount))
                    values.other.push((data.other_amount))
                }else{
                    values.st.push(data.st_count)
                    values.dl.push(data.dl_count)
                    values.other.push(data.other_count)
                }
            })

            this.chart.trend_bar.data = {
                labels: labels,
                datasets: [
                    {
                        label: 'Streaming',  // 이름
                        backgroundColor: "#36a2eb",                                                  // Bar Color
                        data: values.st,                      // 데이터 수치
                    },
                    {
                        label: 'Download',    // 이름
                        backgroundColor: "#ff6484",                                                   // Bar Color
                        data: values.dl,                      // 데이터 수치
                    },
                    {
                        label: 'Other',       // 이름
                        backgroundColor: "#4cc0c0",                                                   // Bar Color
                        data: values.other,                      // 데이터 수치
                    },
                ]
            }
            this.monthSaleTable.listData = result.items.reverse()
          })
          .catch(error =>{
              console.log("stats monthly Error ::", error)
        })
    },
    getTop10(){
      let payload = {
        id : this.$route.params.id, 
        url : 'album', // album, track, artist , country, monthly, store, track
        params : {
          sort: 'total_amount',
          sortorder: 'DESC',
          page: 0,
          limit: 10,
          date_type: this.statDateType,
          start_month: moment(this.statStartDate).format('yyyyMM'),
          end_month: moment(this.statEndDate).format('yyyyMM'),
          get_sub: true,
        }
      }
 
      return this.$store.dispatch("GET_USER_STATS", payload)
      .then(result =>{
          this.top10Table.listData = result.items
      }).catch(error =>{
            console.log("stats monthly Error ::", error)
        })
    },
    statSummary(){
      this.statStep = "summary"
      this.loadingShow();
      let t = this
      const api1 = new Promise(resolve =>{
        
        this.getStatMonthly('monthly').then(result =>{
          resolve(true)
        }).catch(error => resolve(false))
      })
      const api2 = new Promise(resolve =>{
        resolve(true)
        // this.getTop10().then(result =>{
        //   resolve(true)
        // }).catch(error => resolve(false))
      })
      Promise.all([api1,api2])
      .then(result =>{
        this.loadingHide();
        console.log("advancepayment update02 :::", result)
     
      })
      
      
    },
    loadAlbumPopular(){
        let payload = {
          id : this.$route.params.id, 
          url : 'album', // album, track, artist , country, monthly, store, track
          params : {
            date_type: this.statDateType,
            start_month: moment(this.statStartDate).format('yyyyMM'),
            end_month: moment(this.statEndDate).format('yyyyMM'),
          }
        }
        return this.$store.dispatch("GET_USER_STATS_POPULAR",payload)
        .then(result =>{
            return result; console.log('pop',result)
          
        })
        
    },
    loadTrackPopular(){
        let payload = {
          id : this.$route.params.id, 
          url : 'track', // album, track, artist , country, monthly, store, track
          params : {
            date_type: this.statDateType,
            start_month: moment(this.statStartDate).format('yyyyMM'),
            end_month: moment(this.statEndDate).format('yyyyMM'),
          }
        }
        return this.$store.dispatch("GET_USER_STATS_POPULAR", payload)
          .then(result =>{
            return result
        })
    },
    statAlbumeSale(){
      let payload = {
        id : this.$route.params.id, 
        url : 'album', // album, track, artist , country, monthly, store, track
        params : {
          sort: 'total_amount',
          sortorder: 'DESC',
          page: this.albumTrackTable.currentPage - 1 ,
          limit: 20,
          date_type: this.statDateType,
          start_month: moment(this.statStartDate).format('yyyyMM'),
          end_month: moment(this.statEndDate).format('yyyyMM'),
          get_track: true
        }
      }
 
      return this.$store.dispatch("GET_USER_STATS", payload)
      .then(result =>{
          result.items.forEach((item) => {
              item.toggle = false
          })
       
          const remainder = parseInt(result.filtered % 20 ) > 0? 1: 0
          this.albumTrackTable.totalPage = parseInt(result.filtered / 20 ) + remainder
          this.albumTrackTable.listData = result.items
      }).catch(error =>{
            console.log("stats monthly Error ::", error)
        })
    },
    statAlbum(){
      this.statStep = "album"
      const api1 = new Promise(resolve =>{
        this.loadAlbumPopular().then(result =>{
          console.log('asdfasdf',result);
          this.setPopularChart('album_popular', result)
          resolve(true)
          
        }).catch(error => {
          console.log('dd',error) 
          resolve(false) })
      })
      const api2 = new Promise(resolve =>{
        this.loadTrackPopular().then(result =>{
          this.setPopularChart('track_popular', result)
          resolve(true)
        }).catch(error => resolve(false))
      })
      const api3 = new Promise(resolve =>{
        
        this.statAlbumeSale().then(result =>{
          resolve(true)
        }).catch(error => resolve(false))
      })
      
      this.loadingShow();
      Promise.all([api1,api2,api3])
      .then(result =>{
        
        this.loadingHide();
        console.log("track_popular :::", result)
     
      })
    },
   
    
    statArtistSale(){
      let payload = {
        id : this.$route.params.id, 
        url : 'artist', // album, track, artist , country, monthly, store, track
        params : {
          sort: 'total_amount',
          sortorder: 'DESC',
          page: this.artistTable.currentPage - 1 ,
          limit: 20,
          date_type: this.statDateType,
          start_month: moment(this.statStartDate).format('yyyyMM'),
          end_month: moment(this.statEndDate).format('yyyyMM'),
          get_track: true
        }
      }
 
      return this.$store.dispatch("GET_USER_STATS", payload)
      .then(result =>{
          result.items.forEach((item) => {
              item.toggle = false
          })
       
          const remainder = parseInt(result.filtered % 20 ) > 0? 1: 0
          this.artistTable.totalPage = parseInt(result.filtered / 20 ) + remainder
          this.artistTable.listData = result.items
      }).catch(error =>{
            console.log("stats monthly Error ::", error)
        })
    },
    loadArtistPopular(){
        let payload = {
          id : this.$route.params.id, 
          url : 'artist', // album, track, artist , country, monthly, store, track
          params : {
            date_type: this.statDateType,
            start_month: moment(this.statStartDate).format('yyyyMM'),
            end_month: moment(this.statEndDate).format('yyyyMM'),
          }
        }
        return this.$store.dispatch("GET_USER_STATS_POPULAR", payload)
          .then(result =>{
            return result
        })
    },
    statArtist(){
      this.statStep = "artist"
      const api1 = new Promise(resolve =>{
        this.statArtistSale().then(result =>{
          resolve(true)
          
        }).catch(error => {
          console.log('dd',error) 
          resolve(false) })
      })
      const api2 = new Promise(resolve =>{
        this.loadArtistPopular().then(result =>{
          this.setPopularChart('artist_popular', result)
          resolve(true)
        }).catch(error => resolve(false))
      })
     
      
      this.loadingShow();
      Promise.all([api1,api2])
      .then(result =>{
        
        this.loadingHide();
        console.log("track_popular :::", result)
     
      })
    },

    statStoreSale(){
      let payload = {
        id : this.$route.params.id, 
        url : 'store', // album, track, artist , country, monthly, store, track
        params : {
          sort: 'total_amount',
          sortorder: 'DESC',
          page: this.storeTable.currentPage - 1 ,
          limit: 20,
          date_type: this.statDateType,
          start_month: moment(this.statStartDate).format('yyyyMM'),
          end_month: moment(this.statEndDate).format('yyyyMM'),
          get_track: true
        }
      }
 
      return this.$store.dispatch("GET_USER_STATS", payload)
      .then(result =>{
          result.items.forEach((item) => {
              item.toggle = false
          })
       
          const remainder = parseInt(result.filtered % 20 ) > 0? 1: 0
          this.storeTable.totalPage = parseInt(result.filtered / 20 ) + remainder
          this.storeTable.listData = result.items
      }).catch(error =>{
            console.log("stats monthly Error ::", error)
        })
    },
    loadStorePopular(){
        let payload = {
          id : this.$route.params.id, 
          url : 'store', // album, track, artist , country, monthly, store, track
          params : {
            date_type: this.statDateType,
            start_month: moment(this.statStartDate).format('yyyyMM'),
            end_month: moment(this.statEndDate).format('yyyyMM'),
          }
        }
        return this.$store.dispatch("GET_USER_STATS_POPULAR", payload)
          .then(result =>{
            return result
        })
    },


    statStore(){
      this.statStep = "store"

      const api1 = new Promise(resolve =>{
        this.statStoreSale().then(result =>{
          resolve(true)
          
        }).catch(error => {
          console.log('dd',error) 
          resolve(false) })
      })
      const api2 = new Promise(resolve =>{
        this.loadStorePopular().then(result =>{
          this.setPopularChart('store_popular', result)
          resolve(true)
        }).catch(error => resolve(false))
      })
     
      this.loadingShow();
      Promise.all([api1,api2])
      .then(result =>{
        
        this.loadingHide();
     
      })
    },
    getAmountVal(val){
        let value = 0
        if(val){
            value = String(val).replace(/,/g, '')
        }
        if(this.currency == 'krw'){
            value = Math.floor(value)
        }else{
            value = Math.floor(value * 100) / 100
        }
        return value
    },
    statCountrySale(){
      let payload = {
        id : this.$route.params.id, 
        url : 'country', // album, track, artist , country, monthly, store, track
        params : {
          sort: 'total_amount',
          sortorder: 'DESC',
          page: this.countryTable.currentPage - 1 ,
          limit: 300,
          date_type: this.statDateType,
          start_month: moment(this.statStartDate).format('yyyyMM'),
          end_month: moment(this.statEndDate).format('yyyyMM'),
          get_track: true
        }
      }
 
      return this.$store.dispatch("GET_USER_STATS", payload)
      .then(result =>{
          
          this.countryChart = {
            "KR" : 0,
          }
          result.items.forEach((data)=> {
                if(data.total_amount != 0 &&  data.title != 'Global'){
                  if( this.countryChart[data.title.toUpperCase()]){
                      this.countryChart[data.title.toUpperCase()] = this.getAmountVal(this.countryChart[data.title.toUpperCase()] + data.total_amount )
                  }else{
                      this.countryChart[data.title.toUpperCase()] = this.getAmountVal(data.total_amount)
                  }
                }
              
          })
          console.log(this.countryChart)
          const remainder = parseInt(result.filtered % 20 ) > 0? 1: 0
          this.countryTable.totalPage = parseInt(result.filtered / 20 ) + remainder
          this.countryTable.listData = result.items
      }).catch(error =>{
            console.log("stats monthly Error ::", error)
        })
    },
    loadCountryPopular(){
        let payload = {
          id : this.$route.params.id, 
          url : 'country', // album, track, artist , country, monthly, store, track
          params : {
            date_type: this.statDateType,
            start_month: moment(this.statStartDate).format('yyyyMM'),
            end_month: moment(this.statEndDate).format('yyyyMM'),
          }
        }
        return this.$store.dispatch("GET_USER_STATS_POPULAR", payload)
          .then(result =>{
            return result
        })
    },
    statCountry(){
      this.statStep = "country"
      const api1 = new Promise(resolve =>{
        this.statCountrySale().then(result =>{
          resolve(true)
          
        }).catch(error => {
          console.log('dd',error) 
          resolve(false) })
      })
      const api2 = new Promise(resolve =>{
        this.loadCountryPopular().then(result =>{
          this.setPopularChart('country_popular', result)

          resolve(true)
        }).catch(error => resolve(false))
      })
     
      this.loadingShow();
      Promise.all([api1,api2])
      .then(result =>{
        
        this.loadingHide();
     
      })
    },
    searchStack(){
      this.albumTrackTable.currentPage = 1
      this.artistTable.currentPage = 1
      this.storeTable.currentPage = 1
      if(this.statStep == 'summary')this.statSummary()
      
      if(this.statStep == 'album')this.statAlbum()

      if(this.statStep == 'artist')this.statArtist()

      if(this.statStep == 'store')this.statStore()
      
      if(this.statStep == 'country')this.statCountry()
    },

    statExcel(type){
      let payload ={
        id : this.$route.params.id, 
        url : type,
        params:{
          
          sort: 'total_amount',
          sortorder: 'DESC',
          date_type: this.statDateType,
          start_month: moment(this.statStartDate).format('yyyyMM'),
          end_month: moment(this.statEndDate).format('yyyyMM'),
          
        }
      }
      if(type=="album"){
        payload.params['get_track'] = true
      }
      this.loadingShow()
      this.$store.dispatch("GET_USER_STATS_EXCEL", payload)
      .then(result =>{
          this.loadingHide()
          console.log()
          this.getExcelFileDown(result)
      }).catch(error =>{
        console.log("stats monthly Error ::", error)
      })
    },


    trackListExecl(){
      let payload = {
        id : this.object.id,
        params : {
          date_type : this.trackType,
          start_date : this.trackStartDate,
          end_date : this.trackEndDate
        }
      }
      
      this.loadingShow()
      this.$store.dispatch("GET_LICENSOR_TRACKLIST_EXCEL", payload)
      .then(result =>{
          this.loadingHide()
          this.alert({msg: '다운로드 요청을 성공하였습니다. <br/> 작업이 완료되면 알림(slack)으로 전송 될 것입니다.'})
      }).catch(error =>{
        console.log("stats monthly Error ::", error)
      })
    },
    userSettleExecl(){
      let payload = {
        id : this.$route.params.id, 
        params : {
          "sort": "created_at", 
	        "sortorder": "DESC", 
          date_type : this.settleType,
          start_month : this.settleStartDate,
          end_month : this.settleEndDate,
        }
      }
      
      this.loadingShow()
      this.$store.dispatch("GET_USER_SETTLEMENT_EXCEL", payload)
      .then(result =>{
          this.loadingHide()
          this.getExcelFile(result)
      }).catch(error =>{
        console.log("stats monthly Error ::", error)
      })
    }, 
    managerCall(){
        this.loadingShow()
        const option = {
            sort: 'admin_nickname',
            sortorder: 'asc',
            page: 0 ,
            limit: 100,
        }
        option['state'] = 'verified'
        option['role'] = 'admin'
        this.$store.dispatch('GETUSER', option)
        .then(result =>{
          this.loadingHide()
            this.managerList = [
                ...result.items
              
            ]
        }).catch(error=>{
            this.loadingHide()
            const status = error.response.status
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                this.alert({msg:error.response.data.message })
                break;
            }
        })
    },
    openNoti(){
      
      this.notiData = {
        release_data: null,
        album_name : null,
        artist_name : null,
        remark : null
      }
      this.openModal('noti')
    },
    postRequestNoti(){
      let payload = {
        id : this.object.id,
        params : {
          // "album_name": "Album Name",
          // "artist_name": "Artist Name",
          // "release_date": "Release Date",
          // "remarks": "내일 까지 제출 부탁드립니다. (테스트))"
          ...this.notiData
        }
      }
      if(this.valCheck(this.notiData.album_name)){
        this.alert({msg: '앨범명을 입력해주세요.'})
        return false
      }
      if(this.valCheck(this.notiData.artist_name)){
        this.alert({msg: '아티스트이름을 입력해주세요.'})
        return false
      }
      if(this.valCheck(this.notiData.release_date)){
        this.alert({msg: '발매예정일을 입력해주세요.'})
        return false
      }
      if(this.valCheck(this.notiData.remarks)){
        this.alert({msg: '요청사항을 입력해주세요.'})
        return false
      }
      this.loadingShow()
      this.$store.dispatch('POST_REQUEST_NOTIFICATION', payload)
        .then(result =>{
          this.loadingHide()
          this.alert({
            msg: `
              권리자에게 자료요청 알림톡 발송을 요청하였습니다.
            `
          })
          this.closeModal('noti')
         
        }).catch(error=>{
            this.loadingHide()
            const status = error.response.status
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                this.alert({msg:error.response.data.message })
                break;
            }
        })
    },
    permissionSave(){
       let params = {
        id: this.$route.params.id,
        permissions : this.permissions
      }
      
      this.loadingShow()
      
      const payload = {id : params.id, params: params}
      
      this.$store.dispatch("PUTUSER", payload)
      .then(result =>{
        this.loadingHide();
        this.$vs.notify({text:'수정 되었습니다.',position:'top-center'})
        this.call();
      }).catch(error =>{
        this.loadingHide();
        switch(error.response.data.code) {
          default:
             this.alert({msg:error})
            break;
        }
      })
    }
  }

}
</script>

<style scoped>

</style>
